/**
 * @generated SignedSource<<6f7d8254e25603ec105571d7f0669898>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type useNavSettingsService$data = {
  readonly properties: {
    readonly nodes: ReadonlyArray<{
      readonly key: string | null | undefined;
      readonly value: string | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly sidebar: {
    readonly nodes: ReadonlyArray<{
      readonly menuId: string | null | undefined;
      readonly visible: boolean | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useNavSettingsService";
};
export type useNavSettingsService$key = {
  readonly " $data"?: useNavSettingsService$data;
  readonly " $fragmentSpreads": FragmentRefs<"useNavSettingsService">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "__relay_internal__pv__getpagesizevaluerelayproviderts"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__getpagesizevaluerelayproviderts"
    }
  ],
  "kind": "Fragment",
  "name": "useNavSettingsService",
  "selections": [
    {
      "args": (v0/*: any*/),
      "concreteType": "SettingsMenuItemConnection",
      "kind": "LinkedField",
      "name": "sidebar",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsMenuItem",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "menuId"
            },
            {
              "kind": "ScalarField",
              "name": "visible"
            }
          ]
        }
      ]
    },
    {
      "args": (v0/*: any*/),
      "concreteType": "SettingsDisplayPropertyConnection",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "SettingsDisplayProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "key"
            },
            {
              "kind": "ScalarField",
              "name": "value"
            }
          ]
        }
      ]
    }
  ],
  "type": "SettingsNavigationCustomisation"
};
})();

(node as any).hash = "3eeb846e40561ac05736d40d381db293";

export default node;
